import { render, staticRenderFns } from "./BookingWidgetStats.vue?vue&type=template&id=e03c97de"
import script from "./BookingWidgetStats.vue?vue&type=script&lang=js"
export * from "./BookingWidgetStats.vue?vue&type=script&lang=js"
import style0 from "./BookingWidgetStats.vue?vue&type=style&index=0&id=e03c97de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports